import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, Grid, Cell } from 'react-md';
import { validate, validationRules } from '../utils/validationUtils';

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this.getInitialFormState()
    };
    this.formConstraints = {
      name: [validationRules.required],
      email: [validationRules.required, validationRules.email],
      message: [validationRules.required]
    };
  }

  getInitialFormState = () => ({
    name: "",
    email: "",
    message: ""
  })

  handleSubmit = e => {
    const { onSubmit } = this.props;
    const { form } = this.state;
    const formErrors = validate(form, this.formConstraints);
    this.setState({ formErrors });
    if (!formErrors && onSubmit) {
      onSubmit(form);
    }
    e.preventDefault();
  };

  handleBlur = e => {
    const targetName = e.target.name;
    const { form } = this.state;
    const formErrors = this.state.formErrors || {};
    const nextFormErrors = validate(form, this.formConstraints) || {};
    this.setState({ formErrors: { ...formErrors, [targetName]: nextFormErrors[targetName]} });
  };

  reset = () => {
    this.setState({
      form: this.getInitialFormState(),
      formErrors: null
    })
  }

  handleChange = (value, e) => this.setState({ form: {...this.state.form, [e.target.name]: value }});

  getNetlifyForm = () => `
    <form name="contact" netlify netlify-honeypot="bot-field" hidden>
      <input type="text" name="name" />
      <input type="email" name="email" />
      <textarea name="message"></textarea>
    </form>
  `;

  render() {
    const { form } = this.state;
    const formErrors = this.state.formErrors || {};
    return (
      <article>
        <h2 className="md-text-center">Contact</h2>
        <div dangerouslySetInnerHTML={{ __html: this.getNetlifyForm() }} />
        <form onSubmit={this.handleSubmit}>
          <Grid className="grid-example">
            <Cell size={6} tabletSize={4} phoneSize={4}>
              <TextField
                id="name"
                name="name"
                value={form.name}
                label="Your Name"
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                error={!!formErrors.name}
                errorText={formErrors.name}
              />
            </Cell>
            <Cell size={6} tabletSize={4} phoneSize={4}>
              <TextField
                id="email"
                name="email"
                value={form.email}
                label="Your Email"
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                error={!!formErrors.email}
                errorText={formErrors.email}
              />
            </Cell>
            <Cell size={12} tabletSize={8} phoneSize={4}>
              <TextField
                id="message"
                name="message"
                value={form.message}
                label="Message"
                rows={3}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                error={!!formErrors.message}
                errorText={formErrors.message}
              />
            </Cell>
          </Grid>
          <div className="md-text-center"><Button raised secondary type="submit" iconClassName="fa fa-envelope-o">Send</Button></div>
        </form>
      </article>
    );
  }
};

ContactForm.propTypes = {
  onSubmit: PropTypes.func
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js